import { useEffect, useState } from 'react';
import useAuth from 'client/utils/auth/useAuth';
import { useIntl } from 'react-intl';

import Dialog from 'client/components/aria/Dialog/Dialog';
import Alert from 'client/components/ui/Alert/Alert';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './AutoLogout.module.scss';

const AutoLogout = (props) => {
    const { prompting, isAuthenticated, refresh } = useAuth();
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(Boolean(isAuthenticated && prompting));
    }, [prompting]);

    const handleClose = () => {
        setIsOpen(false);
        refresh();
    };

    return (
        <Dialog
            data-testid="autoLogout"
            isOpen={isOpen}
            onClose={handleClose}
            isDismissable
            aria-labelledby={'autoLogout.dialog.title'}
            {...props}
        >
            <Alert role="document">
                <h2
                    id="autoLogout.dialog.title"
                    data-testid="autoLogout.title"
                    className={[styles.title, 'govuk-error-summary__title'].join(' ')}
                >
                    {intl.formatMessage({ id: 'autoLogout.inactivity' })}
                </h2>
                <span
                    data-testid="autoLogout.subtitle"
                    className="govuk-caption-m govuk-!-text-align-centre"
                >
                    {intl.formatMessage({ id: 'autoLogout.continue' })}
                </span>

                <ButtonGroup className={styles.actionRow}>
                    <Button
                        onPress={handleClose}
                        variant="success"
                        data-testid="autoLogout.button"
                        aria-label={intl.formatMessage({ id: 'autoLogout.button.ariaLabel' })}
                    >
                        {intl.formatMessage({ id: 'ok' })}
                    </Button>
                </ButtonGroup>
            </Alert>
        </Dialog>
    );
};

AutoLogout.propTypes = {
    ...defaultAriaProps
};

export default AutoLogout;
